<ion-list lines="true">
  <ion-item (click)="openRecordingMenu()" button="true" lines="none">
    <ion-icon src="/assets/icons/24px/chevron-left.svg" slot="start"> </ion-icon>
    <ion-label> Back </ion-label>
  </ion-item>

  <!-- <ion-item lines="full" button="true" href="/upgrade" *ngIf="(walletService.plan$ | async)?.videoRecording">
    <ion-icon src="/assets/icons/24px/video-playback.svg" slot="start"> </ion-icon>

    <ion-label class="ion-text-wrap"> Upgrade to Unlock Video Recording </ion-label>
  </ion-item> -->

  <ion-item (click)="download('mp4')" [disabled]="!recording.mp4" button="true" lines="none">
    <ion-icon src="/assets/icons/24px/download.svg" slot="start"> </ion-icon>

    <ion-label>
      Download mp4

      <p>Audio + Video</p>
    </ion-label>
  </ion-item>

  <ion-item (click)="download('webm')" *ngIf="recording.webm" button="true" lines="none">
    <ion-icon src="/assets/icons/24px/download.svg" slot="start"> </ion-icon>

    <ion-label>
      Download webm

      <p>Video Only</p>
    </ion-label>
  </ion-item>

  <ion-item
    (click)="download('wav')"
    [disabled]="!recording.wav"
    *ngIf="!recording.screenRecording"
    button="true"
    lines="none">
    <ion-icon src="/assets/icons/24px/download.svg" slot="start"> </ion-icon>

    <ion-label>
      Download wav

      <p>Audio Only</p>
    </ion-label>
  </ion-item>

  <ion-item
    (click)="download('mp3')"
    [disabled]="!recording.mp3"
    *ngIf="!recording.screenRecording"
    button="true"
    lines="none">
    <ion-icon src="/assets/icons/24px/download.svg" slot="start"> </ion-icon>

    <ion-label>
      Download mp3

      <p>Audio Only</p>
    </ion-label>
  </ion-item>
</ion-list>
